import styled from "@xstyled/styled-components";

import { Spacing, media, ResponsiveImage } from "@otta/design";
import { pxToRem, palette } from "@otta/design-tokens";
import { INBOX_WIDTH } from "@otta/search/globalConstants";

const StyledImage = styled(ResponsiveImage)`
  width: 100%;
  max-height: ${pxToRem(160)};
  max-width: ${pxToRem(160)};
  margin: -15% 0;
`;

const TextWrapper = styled.div`
  p {
    margin: 0 auto;
    max-width: ${pxToRem(400)};
  }
`;

const Centered = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  ${media({ to: 500 })`
    display: none;
  `}
  ${media({ to: "desktop" })`
    margin-left: ${INBOX_WIDTH}px;
  `}
  ${media({ from: "desktop" })`
    margin-left: 0;
  `}
`;

export function MessagePlaceholder(): React.ReactElement {
  return (
    <Centered
      style={{
        backgroundColor: palette.grayscale.shade200,
      }}
    >
      <StyledImage
        alt="Otta logo"
        widths={[640, 768, 1024]}
        src={width =>
          `https://static.otta.com/hero-images/colourway-1/shine_brighter_${width}.png`
        }
        sources={{
          "image/webp": width =>
            `https://static.otta.com/hero-images/colourway-1/shine_brighter_${width}.webp`,
        }}
      />
      <TextWrapper>
        <Spacing size={-2}>
          <h1>Messages from companies</h1>
          <p>
            Here you can respond to companies that have reached out with
            opportunities for you on Otta
          </p>
        </Spacing>
      </TextWrapper>
    </Centered>
  );
}
